// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import {
//   Dropdown,
//   DropdownToggle,
//   DropdownMenu,
//   Row,
//   Col,
//   Media,
// } from "reactstrap";
// import SimpleBar from "simplebar-react";

// //i18b
// import { withNamespaces } from "react-i18next";

// //Import images
// import avatar3 from "../../../assets/images/users/avatar-3.jpg";
// import avatar4 from "../../../assets/images/users/avatar-4.jpg";

// class NotificationDropdown extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       menu: false,
//     };
//     this.toggle = this.toggle.bind(this);
//   }

//   toggle() {
//     this.setState((prevState) => ({
//       menu: !prevState.menu,
//     }));
//   }
//   render() {
//     return (
//       <React.Fragment>
//         <Dropdown
//           isOpen={this.state.menu}
//           toggle={this.toggle}
//           className="d-inline-block"
//         >
//           <DropdownToggle
//             tag="button"
//             className="btn header-item noti-icon waves-effect"
//             id="page-header-notifications-dropdown"
//           >
//             <i className="ri-notification-3-line"></i>
//             <span className="noti-dot"></span>
//           </DropdownToggle>
//           <DropdownMenu
//             right
//             className="dropdown-menu-lg p-0"
//             aria-labelledby="page-header-notifications-dropdown"
//           >
//             <div className="p-3">
//               <Row className="align-items-center">
//                 <Col>
//                   <h6 className="m-0"> {this.props.t("Notifications")} </h6>
//                 </Col>
//                 {/* <div className="col-auto">
//                                             <Link to="#" className="small"> {this.props.t('View All')}</Link>
//                                         </div> */}
//               </Row>
//             </div>
//             <SimpleBar style={{ maxHeight: "230px" }}>
//               {/* <DropdownMenu
//                 right
//                 style={{
//                   overflowY: "scroll",
//                   position: "relative",
//                   height: "auto",
//                 }}
//               >
//                 {loading ? (
//                   <div style={{ display: "flex", justifyContent: "center" }}>
//                     <ClipLoader
//                       color={"#000000"}
//                       loading={loading}
//                       size={40}
//                       aria-label="Loading Spinner"
//                       speedMultiplier={1}
//                     />
//                   </div>
//                 ) : (
//                   notif.map((notification, index) => (
//                     <a
//                       href={`/loan-detail/${notification._id}/${notification.loan_id}`}
//                     >
//                       <DropdownItem
//                         key={index}
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           flexWrap: "wrap",
//                           width: "500px",
//                           overflowX: "hidden",
//                           maxHeight: "200px",
//                           border: "1px solid #ddd",
//                           padding: "10px",
//                           backgroundColor: notification.read
//                             ? "#f1f5f7"
//                             : "#242a3a",
//                           fontFamily: "Times New Roman",
//                           color: notification.read ? "black" : "#a7a9b0",
//                         }}
//                       >
//                         <span style={{ fontSize: "20px", fontWeight: "bold" }}>
//                           {notification.title}
//                         </span>
//                         <span style={{ fontSize: "17px" }}>
//                           {notification.message}
//                         </span>
//                         <span style={{ fontSize: "17px" }}>
//                           {" "}
//                           Created At: {notification.formattedCreatedAt}
//                         </span>
//                       </DropdownItem>
//                     </a>
//                   ))
//                 )}
//               </DropdownMenu> */}
//               {notif.map(()=> {
//             return <Link to="#" className="text-reset notification-item">
//              <Media>
//                {/* <div >
//                  <span className="avatar-title bg-primary rounded-circle font-size-16">
//                    <i className="ri-shopping-cart-line"></i>
//                  </span>
//                </div> */}
//                <Media body>
//                  <h6 className="mt-0 mb-1">
//                    {this.props.t("Your order is placed")}
//                  </h6>
//                  <div className="font-size-12 text-muted">
//                    <p className="mb-1">
//                      {this.props.t(
//                        "If several languages coalesce the grammar"
//                      )}
//                    </p>
//                    <p className="mb-0">
//                      <i className="mdi mdi-clock-outline"></i>{" "}
//                      {this.props.t("3 min ago")}
//                    </p>
//                  </div>
//                </Media>
//              </Media>
//            </Link>
//               })}

//             </SimpleBar>
//             <div className="p-2 border-top">
//               <Link
//                 to="#"
//                 className="btn btn-sm btn-link font-size-14 btn-block text-center"
//               >
//                 <i className="mdi mdi-arrow-right-circle mr-1"></i>
//                 {this.props.t(" View More")}
//               </Link>
//             </div>
//           </DropdownMenu>
//         </Dropdown>
//       </React.Fragment>
//     );
//   }
// }
// export default withNamespaces()(NotificationDropdown);

import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Media,
  Card,
  CardBody,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import useGetAuthed from "../../../helpers/hooks/useGetAuthed";
import usePutAuthed from "../../../helpers/hooks/usePutAuthed";
import logo from "../../../assets/images/logo-dark__.png";


const NotificationDropdown = ({ t }) => {
  const [menu, setMenu] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatedNotifications, setUpdatedNotifications] = useState([]);
  const [notif, setNotif] = useState([]);
  const [count, setCount] = useState([]);
  const [id, setId] = useState("");
  const [isCountVisible, setIsCountVisible] = useState(true);

  const [authData, errorAuth, loadingAuth, callAuth] = useGetAuthed(
    "get_notifications",
    true,
    "loan"
  );
  const [call, updateData, updateError, updateLoading] = usePutAuthed(
    `read_notification/${id}`,
    "loan"
  );

  const [notifications, setNotifications] = useState([]);
  




  useEffect(() => {
    if (!loadingAuth && authData) {
      const formattedNotifications = authData.notifications.map(
        (notification) => {
          const date = new Date(notification.createdAt);
          const formattedDate = `${date.getDate()} - ${
            date.getMonth() + 1
          } - ${date.getFullYear()}`;
          return {
            ...notification,
            formattedCreatedAt: formattedDate,
          };
        }
      );

      setNotif(formattedNotifications.reverse());
      const filteredNotifications = formattedNotifications.filter(
        (notification) => !notification.read
      );
      setCount(filteredNotifications.length);
      setLoading(false);
      console.log(formattedNotifications);
    } else if (!loadingAuth && errorAuth) {
      setError(errorAuth);
      setLoading(false);
    }
    setUpdatedNotifications([]);
  }, [authData, errorAuth, loadingAuth]);

  const handleNotificationClick = (notificationId) => {
    call(null, `read_notification/${notificationId}`);
    const updatedNotif = notif.map((notification) =>
      notification._id === notificationId
        ? { ...notification, read: true }
        : notification
    );
    setUpdatedNotifications([...updatedNotifications, notificationId]);
    setNotif(updatedNotif);

    const filteredNotifications = updatedNotif.filter(
      (notification) => !notification.read
    );
    setCount(filteredNotifications.length);
  };
  const toggle = () => {
    setIsCountVisible((prev) => !prev);
    setMenu((prevState) => !prevState);
  };

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        
        <DropdownToggle
          tag="button"
          className="btn header-item noti-icon waves-effect"
          id="page-header-notifications-dropdown"
        >
          <i className="ri-notification-2-line"></i>
          {isCountVisible && count > 0 && (
            <span
              style={{
                color: "red",
                display: "inline-block",
                position: "absolute",
                right: "0.1rem",
                top: "1em",
                fontWeight: "bold",
              }}
            >
              +{count}
            </span>
          )}
        </DropdownToggle>

        <DropdownMenu
        right
        // right={isResponsive}
          className="dropdown-menu-lg p-0"
          aria-labelledby="page-header-notifications-dropdown"
          style={{ width: "300px"}}
        >
          <SimpleBar style={{ maxHeight: "400px" }}>
            {loading ? (
              <Card>
                <CardBody className="text-center">
                  <Spinner className="mr-2" color="primary"></Spinner>
                </CardBody>
              </Card>
            ) : 
              notif.map((notification, index) => (
                  <Link
                    key={index}
                    to={`/loan-analytics/${notification.loan_id}/${notification._id}`}
                    className={`text-reset notification-item`}
                    onClick={(e) => {
                      setId(notification._id);
                      handleNotificationClick(notification._id);
                    }}
                  >
                    {/* `/loan-analytics/${x?.loan_application?.loan_id}/${x?.loan_application?._id} */}
                    <Media
                      style={{
                        backgroundColor: notification.read ? "" : "#E0E4E6",
                      }}
                    >
                      <div className="avatar-xs mr-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <img src={logo} alt="notif"></img>
                        </span>
                      </div>
                      <Media body>
                        <h6 className="mt-0 mb-1">{t(notification.title)}</h6>
                        <div className="mdi mdi">
                          <p className="mb-1 font-size-15">
                            {t(notification.message)}
                          </p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline mr-2"></i>
                            {t(notification.formattedCreatedAt)}
                          </p>
                        </div>
                      </Media>
                    </Media>
                  </Link>
              ))
            }
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default withNamespaces()(NotificationDropdown);
